import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Avatar from 'fe-design-base/molecules/Avatar';
import Pill from 'fe-design-base/molecules/Pill';
import { PillVariant } from 'fe-design-base/molecules/Pill/Pill';

import { TradeInvited, TradeInvitedCard } from 'features/notifications/types';

import { toI18n } from 'util/i18n';

type Status = 'needs_reply' | 'declined' | 'submitted' | 'rejected';

type TradeInvitedCardProps = {
  invitedUser: TradeInvited;
};

const statuses: Record<Status, { label: string; variant: PillVariant }> = {
  needs_reply: {
    label: toI18n('requests_feed.trade.statuses.pending_buyer'),
    variant: 'warning',
  },
  declined: {
    label: toI18n('requests_feed.trade.statuses.declined'),
    variant: 'error',
  },
  submitted: {
    label: toI18n('requests_feed.statuses.needs_reply'),
    variant: 'warning',
  },
  rejected: {
    label: toI18n('requests_feed.statuses.rejected'),
    variant: 'error',
  },
};

const TradeInvitedCard = ({ invitedUser }: TradeInvitedCardProps) => {
  const { responder, status } = invitedUser;
  const { avatar, first_name, last_name } = responder || {};
  const name = responder ? `${first_name} ${last_name}` : '';
  return (
    <Box bw={1} bcolor="mono400" bradiusm p={16} bgcolor="mono0" gap={8} column>
      <Box row justifyContentSpaceBetween alignItemsCenter>
        <Box row gap={8} justifyContentStart alignItemsCenter>
          <Avatar image={avatar} size="large" />
          <Text variant="bodyBoldTight">{name}</Text>
        </Box>
        <Pill variant={statuses[status as Status].variant}>
          {statuses[status as Status].label}
        </Pill>
      </Box>
    </Box>
  );
};

export default TradeInvitedCard;
